
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("jBr93", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $92eaf5c7836fe907$export$2e2bcd8739ae039);

var $3wLc2 = parcelRequire("3wLc2");

var $eCmI5 = parcelRequire("eCmI5");

var $8gcp6 = parcelRequire("8gcp6");

var $3zQqw = parcelRequire("3zQqw");

var $eHPrB = parcelRequire("eHPrB");

var $bAire = parcelRequire("bAire");

var $dxY2O = parcelRequire("dxY2O");

var $djPl3 = parcelRequire("djPl3");

var $e0UMn = parcelRequire("e0UMn");

var $4nHpX = parcelRequire("4nHpX");

var $4LaL6 = parcelRequire("4LaL6");

var $39vJy = parcelRequire("39vJy");

var $bL5T8 = parcelRequire("bL5T8");

var $7yyo1 = parcelRequire("7yyo1");

var $hIEUb = parcelRequire("hIEUb");

var $lc57B = parcelRequire("lc57B");

var $gytSK = parcelRequire("gytSK");

var $aJkrH = parcelRequire("aJkrH");
async function $92eaf5c7836fe907$var$createInteractionExtraLogPayload(interactionId, interaction, lastInteractionFinish, lastInteractionFinishVCResult) {
    const config = (0, $8gcp6.getConfig)();
    if (!config) throw Error('UFO Configuration not provided');
    const { end: end, start: start, ufoName: ufoName, rate: rate, type: type, abortReason: abortReason, routeName: routeName, previousInteractionName: previousInteractionName, isPreviousInteractionAborted: isPreviousInteractionAborted, abortedByInteractionName: abortedByInteractionName, knownSegments: knownSegments, minorInteractions: minorInteractions } = interaction;
    const sanitisedUfoName = (0, $3zQqw.sanitizeUfoName)(ufoName);
    const configRate = (0, $8gcp6.getExtraInteractionRate)(sanitisedUfoName, type);
    if (!(0, $eCmI5.default)(configRate)) return null;
    const pageVisibilityAtTTAI = (0, $bAire.default)(interaction);
    const isPageLoad = type === 'page_load' || type === 'transition';
    if (!isPageLoad || minorInteractions !== undefined && minorInteractions.length > 0) // Not send if aborted by minor interaction for now
    // Only create payload for page load
    return null;
    const calculatePageVisibilityFromTheStartOfPageLoad = config.enableBetterPageVisibilityApi && isPageLoad;
    const moreAccuratePageVisibilityAtTTAI = calculatePageVisibilityFromTheStartOfPageLoad ? (0, $eHPrB.getMoreAccuratePageVisibilityUpToTTAI)(interaction) : null;
    const extraTTAI = (0, $e0UMn.default)(interaction) ?? undefined;
    const newUFOName = (0, $3zQqw.sanitizeUfoName)(ufoName);
    const finalVCMetrics = await (0, $4nHpX.default)(interaction, true);
    // Check if VC is clean and has valid metric
    const vcRevisionPayload = finalVCMetrics?.['ufo:vc:rev'];
    const effectiveVCRevisionPayload = vcRevisionPayload?.find(({ revision: revision })=>revision === (0, $8gcp6.DEFAULT_TTVC_REVISION));
    if (!effectiveVCRevisionPayload?.clean || effectiveVCRevisionPayload?.['metric:vc90'] === undefined || typeof effectiveVCRevisionPayload?.['metric:vc90'] !== 'number' || extraTTAI === undefined || typeof extraTTAI !== 'number' || interaction.errors.length > 0) return null;
    // Get normal TTAI & VC90 for last finished interaction (without 3p)
    if (!lastInteractionFinish || lastInteractionFinish?.abortReason || lastInteractionFinish?.errors?.length) return null;
    const normalTTAI = (0, $e0UMn.default)(lastInteractionFinish) ?? undefined;
    const lastInteractionFinishStart = typeof lastInteractionFinish.start === 'number' ? Math.round(lastInteractionFinish.start) : undefined;
    const lastInteractionFinishEnd = typeof lastInteractionFinish.end === 'number' ? Math.round(lastInteractionFinish.end) : undefined;
    let lastInteractionFinishVC90 = null;
    let lastInteractionFinishVCClean = false;
    if (lastInteractionFinishVCResult) {
        const lastInteractionFinishVCRev = lastInteractionFinishVCResult['ufo:vc:rev'];
        const lastInteractionFinishRevision = lastInteractionFinishVCRev?.find(({ revision: revision })=>revision === (0, $8gcp6.DEFAULT_TTVC_REVISION));
        if (lastInteractionFinishRevision?.clean) {
            lastInteractionFinishVCClean = true;
            lastInteractionFinishVC90 = lastInteractionFinishRevision['metric:vc90'];
        } else return null;
    } else if (normalTTAI !== undefined && typeof normalTTAI === 'number' && normalTTAI === extraTTAI) {
        // Because TTAI is equal between with and without 3p, we can assume VC90 is also equal
        lastInteractionFinishVC90 = effectiveVCRevisionPayload?.['metric:vc90'];
        lastInteractionFinishVCClean = effectiveVCRevisionPayload?.clean;
    }
    // Helper function to check if labelStack contains third-party type
    const isThirdParty = (labelStack)=>{
        return labelStack?.some((entry)=>'type' in entry && entry.type === 'third-party') ?? false;
    };
    // Pre-filter 3p data
    const filteredData = {
        errors: interaction.errors.filter((error)=>isThirdParty(error.labelStack)),
        spans: [
            ...interaction.spans,
            ...(0, $aJkrH.interactionSpans)
        ].filter((span)=>isThirdParty(span.labelStack)),
        requestInfo: interaction.requestInfo.filter((req)=>isThirdParty(req.labelStack)),
        customTimings: interaction.customTimings.filter((timing)=>isThirdParty(timing.labelStack)),
        apdex: interaction.apdex.filter((apdex)=>isThirdParty(apdex.labelStack)),
        reactProfilerTimings: interaction.reactProfilerTimings.filter((timing)=>isThirdParty(timing.labelStack)),
        customData: interaction.customData.filter((data)=>isThirdParty(data.labelStack)),
        segments: knownSegments.filter((segment)=>isThirdParty(segment.labelStack)),
        marks: interaction.marks.filter((mark)=>isThirdParty(mark.labelStack))
    };
    // Clear atlaskit spans after filtering
    (0, $aJkrH.interactionSpans).length = 0;
    // Detailed payload
    const getDetailedInteractionMetrics = ()=>{
        return {
            errors: filteredData.errors.map(({ labelStack: labelStack, ...others })=>({
                    ...others,
                    labelStack: labelStack && (0, $3zQqw.optimizeLabelStack)(labelStack, (0, $djPl3.getReactUFOPayloadVersion)(interaction.type))
                })),
            holdActive: interaction.hold3pActive ? [
                ...interaction.hold3pActive.values()
            ] : [],
            holdInfo: (0, $bL5T8.optimizeHoldInfo)(interaction.hold3pInfo ?? [], start, (0, $djPl3.getReactUFOPayloadVersion)(interaction.type)),
            spans: (0, $gytSK.optimizeSpans)(filteredData.spans, start, (0, $djPl3.getReactUFOPayloadVersion)(interaction.type)),
            requestInfo: (0, $lc57B.optimizeRequestInfo)(filteredData.requestInfo, start, (0, $djPl3.getReactUFOPayloadVersion)(interaction.type)),
            customTimings: (0, $39vJy.optimizeCustomTimings)(filteredData.customTimings, start)
        };
    };
    const segments3p = !(0, $3wLc2.fg)('platform_ufo_remove_deprecated_config_fields') && config.killswitchNestedSegments ? [] : filteredData.segments;
    const segmentTree = (0, $djPl3.getReactUFOPayloadVersion)(interaction.type) === '2.0.0' ? (0, $3zQqw.buildSegmentTree)(segments3p.map((segment)=>segment.labelStack)) : {};
    const payload = {
        actionSubject: 'experience',
        action: 'measured',
        eventType: 'operational',
        source: 'measured',
        tags: [
            'observability'
        ],
        attributes: {
            properties: {
                // basic
                'event:hostname': window.location?.hostname || 'unknown',
                'event:product': config.product,
                'event:schema': '1.0.0',
                'event:sizeInKb': 0,
                'event:source': {
                    name: 'react-ufo/web',
                    version: (0, $djPl3.getReactUFOPayloadVersion)(interaction.type)
                },
                'event:region': config.region || 'unknown',
                'experience:key': 'custom.interaction-extra-metrics',
                'experience:name': newUFOName,
                interactionMetrics: {
                    namePrefix: config.namePrefix || '',
                    segmentPrefix: config.segmentPrefix || '',
                    interactionId: interactionId,
                    pageVisibilityAtTTAI: pageVisibilityAtTTAI,
                    experimental__pageVisibilityAtTTAI: moreAccuratePageVisibilityAtTTAI,
                    rate: // raw interaction metrics
                    rate,
                    routeName: routeName,
                    type: type,
                    abortReason: abortReason,
                    previousInteractionName: previousInteractionName,
                    isPreviousInteractionAborted: isPreviousInteractionAborted,
                    abortedByInteractionName: abortedByInteractionName,
                    // performance
                    end: Math.round(end),
                    start: Math.round(start),
                    'metric:ttai:3p': extraTTAI,
                    ...finalVCMetrics,
                    segments: (0, $djPl3.getReactUFOPayloadVersion)(interaction.type) === '2.0.0' ? segmentTree : (0, $3zQqw.getOldSegmentsLabelStack)(segments3p, interaction.type),
                    marks: (0, $7yyo1.optimizeMarks)(filteredData.marks, (0, $djPl3.getReactUFOPayloadVersion)(interaction.type)),
                    apdex: (0, $4LaL6.optimizeApdex)(filteredData.apdex, (0, $djPl3.getReactUFOPayloadVersion)(interaction.type)),
                    reactProfilerTimings: (0, $hIEUb.optimizeReactProfilerTimings)(filteredData.reactProfilerTimings, start, (0, $djPl3.getReactUFOPayloadVersion)(interaction.type)),
                    customData: filteredData.customData,
                    ...getDetailedInteractionMetrics()
                },
                'vc:effective:revision': (0, $8gcp6.DEFAULT_TTVC_REVISION),
                lastInteractionFinish: {
                    start: lastInteractionFinishStart,
                    end: lastInteractionFinishEnd,
                    ttai: normalTTAI,
                    vc90: lastInteractionFinishVC90,
                    vcClean: lastInteractionFinishVCClean
                }
            }
        }
    };
    payload.attributes.properties['event:sizeInKb'] = (0, $dxY2O.default)(payload.attributes.properties);
    return payload;
}
var $92eaf5c7836fe907$export$2e2bcd8739ae039 = $92eaf5c7836fe907$var$createInteractionExtraLogPayload;

});
parcelRegister("eHPrB", function(module, exports) {
$parcel$export(module.exports, "getMoreAccuratePageVisibilityUpToTTAI", () => $3219c238d7fa8a52$export$97ea55623bd7f1ae);

var $bAire = parcelRequire("bAire");

var $2Thav = parcelRequire("2Thav");
function $3219c238d7fa8a52$export$97ea55623bd7f1ae(interaction) {
    const old = (0, $bAire.default)(interaction);
    const buffered = (0, $2Thav.getVisibilityStateFromPerformance)(interaction.end);
    if (!buffered) return old;
    if (buffered !== old) return 'mixed';
    return old;
}

});
parcelRegister("bAire", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d64e5fdb086e02d$export$2e2bcd8739ae039);

var $9xf03 = parcelRequire("9xf03");
function $5d64e5fdb086e02d$var$getPageVisibilityUpToTTAI(interaction) {
    const { start: start, end: end } = interaction;
    return (0, $9xf03.getPageVisibilityState)(start, end);
}
var $5d64e5fdb086e02d$export$2e2bcd8739ae039 = $5d64e5fdb086e02d$var$getPageVisibilityUpToTTAI;

});

parcelRegister("2Thav", function(module, exports) {
$parcel$export(module.exports, "getVisibilityStateFromPerformance", () => $36f370024b775b87$export$bcaa23184870682a);
function $36f370024b775b87$export$bcaa23184870682a(stop) {
    try {
        const results = performance.getEntriesByType('visibility-state');
        if (!results || results.length === 0) return null;
        return results.reduce((acc = null, { name: name, startTime: startTime })=>{
            if (startTime > stop) return acc;
            if (acc === null && name === null) return null;
            if (acc === null) return name;
            if (acc !== name) return 'mixed';
            return acc;
        }, null);
    } catch (e) {
        return null;
    }
}

});


parcelRegister("dxY2O", function(module, exports) {
$parcel$export(module.exports, "default", () => $54f462d98448ac28$export$2e2bcd8739ae039);
// Reusable TextEncoder instance to avoid creating new instances
const $54f462d98448ac28$var$textEncoder = new TextEncoder();
function $54f462d98448ac28$export$2e2bcd8739ae039(payload) {
    // Early return for null/undefined to avoid unnecessary processing
    if (!payload) return 0;
    // Use the reusable encoder instance
    return Math.round($54f462d98448ac28$var$textEncoder.encode(JSON.stringify(payload)).length / 1024);
}

});

parcelRegister("e0UMn", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb8602eb9de55cd4$export$2e2bcd8739ae039);

var $bAire = parcelRequire("bAire");
function $bb8602eb9de55cd4$export$2e2bcd8739ae039(interaction) {
    const { start: start, end: end } = interaction;
    const pageVisibilityUpToTTAI = (0, $bAire.default)(interaction);
    return !interaction.abortReason && pageVisibilityUpToTTAI === 'visible' ? Math.round(end - start) : undefined;
}

});

parcelRegister("4nHpX", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd18c411fe5f950b$export$2e2bcd8739ae039);

var $8gcp6 = parcelRequire("8gcp6");

var $aJkrH = parcelRequire("aJkrH");

var $6LL7V = parcelRequire("6LL7V");

var $bAire = parcelRequire("bAire");

var $2hLwb = parcelRequire("2hLwb");
async function $bd18c411fe5f950b$var$getVCMetrics(interaction, include3p = false, excludeSmartAnswersInSearch = false) {
    const config = (0, $8gcp6.getConfig)();
    if (!config?.vc?.enabled) return {};
    if (interaction.type !== 'page_load' && interaction.type !== 'transition' && interaction.type !== 'press') return {};
    const interactionStatus = (0, $6LL7V.default)(interaction);
    const pageVisibilityUpToTTAI = (0, $bAire.default)(interaction);
    const isPageVisible = pageVisibilityUpToTTAI === 'visible';
    const shouldReportVCMetrics = interactionStatus.originalInteractionStatus === 'SUCCEEDED' && isPageVisible;
    // Use per-interaction VC observer if available, otherwise fall back to global
    const observer = interaction.vcObserver;
    if (!observer) return {};
    const isSSREnabled = interaction.type === 'page_load' && (config?.ssr || config?.vc.ssrWhitelist?.includes(interaction.ufoName));
    const ssr = interaction.type === 'page_load' && isSSREnabled ? {
        ssr: (0, $2hLwb.default)(config)
    } : null;
    (0, $aJkrH.postInteractionLog).setVCObserverSSRConfig(ssr);
    const tti = interaction.apdex?.[0]?.stopTime;
    const prefix = 'ufo';
    const result = await observer.getVCResult({
        start: interaction.start,
        stop: interaction.end,
        tti: tti,
        prefix: prefix,
        includeSSRInV3: config.vc?.includeSSRInV3,
        vc: interaction.vc,
        isEventAborted: interactionStatus.originalInteractionStatus !== 'SUCCEEDED',
        experienceKey: interaction.ufoName,
        interactionId: interaction.id,
        includeSSRRatio: config.vc?.includeSSRRatio,
        ...ssr,
        include3p: include3p,
        excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
        interactionType: interaction.type,
        isPageVisible: isPageVisible
    });
    observer.stop(interaction.ufoName);
    if (!include3p) {
        // For Post Interaction, last interaction should be without 3p
        (0, $aJkrH.postInteractionLog).setLastInteractionFinishVCResult(result);
        (0, $aJkrH.interactionExtraMetrics).setLastInteractionFinishVCResult(result);
    }
    const mostRecentVCRevision = (0, $8gcp6.getMostRecentVCRevision)(interaction.ufoName);
    const mostRecentVCRevisionPayload = result?.['ufo:vc:rev']?.find(({ revision: revision })=>revision === mostRecentVCRevision);
    if (!shouldReportVCMetrics || !mostRecentVCRevisionPayload?.clean) return result;
    return {
        ...result,
        'metric:vc90': mostRecentVCRevisionPayload['metric:vc90']
    };
}
var $bd18c411fe5f950b$export$2e2bcd8739ae039 = $bd18c411fe5f950b$var$getVCMetrics;

});
parcelRegister("6LL7V", function(module, exports) {
$parcel$export(module.exports, "default", () => $82bd68e7df0b1077$export$2e2bcd8739ae039);
function $82bd68e7df0b1077$var$getInteractionStatus(interaction) {
    let originalInteractionStatus = interaction.abortReason ? 'ABORTED' : 'SUCCEEDED';
    const hasErrors = interaction.errors.length > 0;
    originalInteractionStatus = hasErrors ? 'FAILED' : originalInteractionStatus;
    // `overrideStatus` is to be deprecated - https://product-fabric.atlassian.net/browse/AFO-3760
    return {
        originalInteractionStatus: originalInteractionStatus,
        overrideStatus: originalInteractionStatus
    };
}
var $82bd68e7df0b1077$export$2e2bcd8739ae039 = $82bd68e7df0b1077$var$getInteractionStatus;

});

parcelRegister("2hLwb", function(module, exports) {
$parcel$export(module.exports, "default", () => $51f93cae3a950303$export$2e2bcd8739ae039);

var $jicK7 = parcelRequire("jicK7");
function $51f93cae3a950303$var$getSSRDoneTimeValue(config) {
    return config?.ssr?.getSSRDoneTime ? config?.ssr?.getSSRDoneTime() : $jicK7.getSSRDoneTime();
}
var $51f93cae3a950303$export$2e2bcd8739ae039 = $51f93cae3a950303$var$getSSRDoneTimeValue;

});
parcelRegister("jicK7", function(module, exports) {
$parcel$export(module.exports, "configure", () => $00af71a0cde21e4b$export$8d21e34596265fa2);
$parcel$export(module.exports, "getSSRTimings", () => $00af71a0cde21e4b$export$bf7408e83532dcd0);
$parcel$export(module.exports, "getSSRSuccess", () => $00af71a0cde21e4b$export$c7ad864055e75537);
$parcel$export(module.exports, "getSSRPhaseSuccess", () => $00af71a0cde21e4b$export$5eade9354185583d);
$parcel$export(module.exports, "getSSRDoneTime", () => $00af71a0cde21e4b$export$3def7672244bab0c);
$parcel$export(module.exports, "getSSRFeatureFlags", () => $00af71a0cde21e4b$export$1c4a9b5e6e22393d);
//
const $00af71a0cde21e4b$var$NESTED_METRIC_SEPARATOR = '/';
function $00af71a0cde21e4b$var$filterEntry(entry) {
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
}
function $00af71a0cde21e4b$var$mapEntry(entry) {
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration),
        ...entry.size ? {
            size: Math.round(entry.size)
        } : {}
    };
}
const $00af71a0cde21e4b$var$SSR_PREFIX = 'ssr';
function $00af71a0cde21e4b$var$mapKey(key) {
    if (key === 'total') return $00af71a0cde21e4b$var$SSR_PREFIX;
    return `${$00af71a0cde21e4b$var$SSR_PREFIX}${$00af71a0cde21e4b$var$NESTED_METRIC_SEPARATOR}${key}`;
}
let $00af71a0cde21e4b$var$config;
function $00af71a0cde21e4b$export$8d21e34596265fa2(ssrConfig) {
    $00af71a0cde21e4b$var$config = ssrConfig;
}
function $00af71a0cde21e4b$export$bf7408e83532dcd0() {
    if (!$00af71a0cde21e4b$var$config?.getTimings) return {};
    const timings = $00af71a0cde21e4b$var$config.getTimings();
    if (!timings) return {};
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($00af71a0cde21e4b$var$filterEntry(entry[1])) acc[$00af71a0cde21e4b$var$mapKey(entry[0])] = $00af71a0cde21e4b$var$mapEntry(entry[1]);
        return acc;
    }, {});
    return ssrTimings;
}
function $00af71a0cde21e4b$export$c7ad864055e75537() {
    return !!$00af71a0cde21e4b$var$config?.getDoneMark();
}
function $00af71a0cde21e4b$export$5eade9354185583d() {
    return $00af71a0cde21e4b$var$config?.getSsrPhaseSuccess?.();
}
function $00af71a0cde21e4b$export$3def7672244bab0c() {
    return $00af71a0cde21e4b$var$config?.getDoneMark() ?? undefined;
}
function $00af71a0cde21e4b$export$1c4a9b5e6e22393d() {
    if (!$00af71a0cde21e4b$var$config?.getFeatureFlags) return undefined;
    try {
        return $00af71a0cde21e4b$var$config.getFeatureFlags() ?? undefined;
    // eslint-disable-next-line no-empty
    } catch (e) {}
    return undefined;
}

});



parcelRegister("4LaL6", function(module, exports) {
$parcel$export(module.exports, "optimizeApdex", () => $ccf5a04b74961611$export$efbacb487c03c9c8);

var $3zQqw = parcelRequire("3zQqw");
function $ccf5a04b74961611$export$efbacb487c03c9c8(apdex, reactUFOVersion) {
    return apdex.map(({ stopTime: stopTime, labelStack: labelStack, ...others })=>({
            ...others,
            stopTime: Math.round(stopTime),
            ...labelStack ? {
                labelStack: (0, $3zQqw.optimizeLabelStack)(labelStack, reactUFOVersion)
            } : {}
        }));
}

});

parcelRegister("39vJy", function(module, exports) {
$parcel$export(module.exports, "optimizeCustomTimings", () => $af63809dfc7b0d84$export$967dd9693261321d);
function $af63809dfc7b0d84$export$967dd9693261321d(customTimings, interactionStart) {
    return customTimings.reduce((result, item)=>{
        Object.keys(item.data).forEach((key)=>{
            if (item.data[key].startTime >= interactionStart) result.push({
                labelStack: [
                    {
                        n: key
                    }
                ],
                startTime: Math.round(item.data[key].startTime),
                endTime: Math.round(item.data[key].endTime)
            });
        });
        return result;
    }, []);
}

});

parcelRegister("bL5T8", function(module, exports) {
$parcel$export(module.exports, "optimizeHoldInfo", () => $8dd6f147c8b82484$export$b983e6c30f3a8c82);

var $3zQqw = parcelRequire("3zQqw");
function $8dd6f147c8b82484$export$b983e6c30f3a8c82(holdInfo, interactionStart, reactUFOVersion) {
    const holdInfoMap = holdInfo.reduce((result, hold)=>{
        const { labelStack: labelStack, name: name, start: start, end: end, ignoreOnSubmit: ignoreOnSubmit } = hold;
        if (labelStack && !ignoreOnSubmit && start >= interactionStart) {
            const label = (0, $3zQqw.stringifyLabelStackFully)([
                ...labelStack,
                {
                    name: name
                }
            ]);
            const startTime = Math.round(start);
            const endTime = Math.round(end);
            const timing = result.get(label) || {
                labelStack: (0, $3zQqw.optimizeLabelStack)([
                    ...labelStack,
                    {
                        name: name
                    }
                ], reactUFOVersion),
                startTime: startTime,
                endTime: endTime
            };
            if (startTime < timing.startTime) timing.startTime = startTime;
            if (endTime > timing.endTime) timing.endTime = endTime;
            result.set(label, timing);
        }
        return result;
    }, new Map());
    return [
        ...holdInfoMap.values()
    ];
}

});

parcelRegister("7yyo1", function(module, exports) {
$parcel$export(module.exports, "optimizeMarks", () => $6e401f576c354c24$export$4f8106ecc7ec1c7f);

var $3zQqw = parcelRequire("3zQqw");
function $6e401f576c354c24$export$4f8106ecc7ec1c7f(marks, reactUFOVersion) {
    return marks.map(({ labelStack: labelStack, time: time, ...others })=>({
            ...others,
            labelStack: labelStack && (0, $3zQqw.optimizeLabelStack)(labelStack, reactUFOVersion),
            time: Math.round(time)
        }));
}

});

parcelRegister("hIEUb", function(module, exports) {
$parcel$export(module.exports, "optimizeReactProfilerTimings", () => $229df5165314fad8$export$70a658ddbf644d3a);

var $3wLc2 = parcelRequire("3wLc2");

var $aJkrH = parcelRequire("aJkrH");

var $3zQqw = parcelRequire("3zQqw");
function $229df5165314fad8$export$70a658ddbf644d3a(reactProfilerTimings, interactionStart, reactUFOVersion) {
    const reactProfilerTimingsMap = reactProfilerTimings.reduce((result, { labelStack: labelStack, startTime: startTime, commitTime: commitTime, actualDuration: actualDuration, type: type })=>{
        if (labelStack && startTime >= interactionStart) {
            const label = (0, $3zQqw.stringifyLabelStackFully)(labelStack);
            const start = Math.round(startTime);
            const end = Math.round(commitTime);
            const timing = result.get(label) || {
                labelStack: (0, $3zQqw.optimizeLabelStack)(labelStack, reactUFOVersion),
                startTime: start,
                endTime: end,
                mountCount: 0,
                rerenderCount: 0,
                renderDuration: 0
            };
            if (start < timing.startTime) timing.startTime = start;
            if (end > timing.endTime) timing.endTime = end;
            if (type === 'mount') timing.mountCount += 1;
            if (type === 'update') timing.rerenderCount += 1;
            if ((0, $aJkrH.segmentUnmountCache).has(label) && (0, $3wLc2.fg)('platform_ufo_segment_unmount_count')) {
                timing.unmountCount = (0, $aJkrH.segmentUnmountCache).get(label) || 0;
                (0, $aJkrH.segmentUnmountCache).delete(label);
            }
            timing.renderDuration += Math.round(actualDuration);
            result.set(label, timing);
        }
        return result;
    }, new Map());
    return [
        ...reactProfilerTimingsMap.values()
    ];
}

});

parcelRegister("lc57B", function(module, exports) {
$parcel$export(module.exports, "optimizeRequestInfo", () => $a2e2549d170d2f5e$export$9b2c740f95fe352d);

var $3zQqw = parcelRequire("3zQqw");
function $a2e2549d170d2f5e$export$9b2c740f95fe352d(requestInfo, interactionStart, reactUFOVersion) {
    const updatedRequestInfo = requestInfo.reduce((result, reqInfo)=>{
        const { labelStack: labelStack, name: name, start: start, end: end, networkStart: networkStart, networkComplete: networkComplete } = reqInfo;
        const startTime = networkStart ?? start;
        const endTime = networkComplete ?? end;
        if (labelStack && start >= interactionStart && endTime) result.push({
            labelStack: (0, $3zQqw.optimizeLabelStack)([
                ...labelStack,
                {
                    name: name
                }
            ], reactUFOVersion),
            startTime: Math.round(startTime),
            endTime: Math.round(endTime)
        });
        return result;
    }, []);
    return updatedRequestInfo;
}

});

parcelRegister("gytSK", function(module, exports) {
$parcel$export(module.exports, "optimizeSpans", () => $68e1f39687c278ac$export$e69673407fa1f9ed);

var $3zQqw = parcelRequire("3zQqw");
function $68e1f39687c278ac$export$e69673407fa1f9ed(spans, interactionStart, reactUFOVersion) {
    const updatedSpans = spans.reduce((result, span)=>{
        const { labelStack: labelStack, type: type, name: name, start: start, end: end } = span;
        if (labelStack && start >= interactionStart) result.push({
            labelStack: (0, $3zQqw.optimizeLabelStack)([
                ...labelStack,
                {
                    name: name
                }
            ], reactUFOVersion),
            startTime: Math.round(start),
            endTime: Math.round(end),
            type: type
        });
        return result;
    }, []);
    return updatedSpans;
}

});



//# sourceMappingURL=create-interaction-extra-metrics-payload.1820d4fe.js.map
